import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-resource-event-vehicle-water-filling',
    templateUrl: './resource-event-vehicle-water-filling.component.html',
    styleUrls: ['./resource-event-vehicle-water-filling.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ResourceEventVehicleWaterFillingComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  @ViewChild('dropDownStation', { static: true }) dropDownStation: AbcDropDownBoxComponent;

  constructor(
    resourcesService: ResourcesService,
    resourceManagerService: ResourceManagerService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }
  protected override onNavigationContextRefresh(): void {
    if (!this.dropDownStation.dataSource) {
      this.dropDownStation.setupForArrayData(
        this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.resourceEventTypes,
        'id',
        'name'
      );
    }
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
